import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row w-100" }
const _hoisted_2 = { class: "card-body w-50" }
const _hoisted_3 = { class: "card-body w-50" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Research Duration"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-bold mb-10 fs-6" }, " IRB approval is for 1-year from approval date. A new application must be resubmitted if data collection requires > 12 months from approval date). ")
], -1)
const _hoisted_5 = { class: "mb-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mb-6" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold form-label" }, "How many months do you anticipate this research will last from the time final approval is granted?")
], -1)
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<option value=\"1 Month\">1 Month</option><option value=\"2 Months\">2 Months</option><option value=\"3 Months\">3 Months</option><option value=\"4 Months\">4 Months</option><option value=\"5 Months\">5 Months</option><option value=\"6 Months\">6 Months</option><option value=\"7 Months\">7 Months</option><option value=\"8 Months\">8 Months</option><option value=\"9 Months\">9 Months</option><option value=\"10 Months\">10 Months</option><option value=\"11 Months\">11 Months</option><option value=\"12 Months\">12 Months</option><option value=\"Greater 12 Months\">Greater 12 Months</option>", 13)
const _hoisted_20 = [
  _hoisted_7
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "mb-6" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold form-label" }, "Please specify the start and end dates of your data gethering")
], -1)
const _hoisted_22 = { class: "fv-row" }
const _hoisted_23 = { class: "row g-9" }
const _hoisted_24 = { class: "col-md-6 fv-row" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "form-label mb-3" }, "Data Gathering Start Date", -1)
const _hoisted_26 = { class: "col-md-6 fv-row" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "form-label mb-3" }, "Data Gathering End Date", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDownSection = _resolveComponent("DropDownSection")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DropDownSection, {
        title: "Review for more information",
        list: _ctx.listDropDownSections
      }, null, 8, ["list"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("select", {
          name: "duration",
          "data-control": "select2",
          "data-hide-search": "true",
          class: "form-select",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step2.duration) = $event))
        }, _hoisted_20, 512), [
          [_vModelSelect, _ctx.step2.duration]
        ]),
        _createVNode(_component_Field, {
          type: "hidden",
          name: "duration",
          class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
          placeholder: "How it will be record?",
          modelValue: _ctx.step2.duration,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.step2.duration) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "duration",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ]),
      _createElementVNode("div", null, [
        _hoisted_21,
        _createVNode(_component_el_form, {
          id: "kt_modal_new_target_form",
          model: _ctx.step2,
          rules: _ctx.rules,
          ref: "formRef",
          class: "form"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_component_el_form_item, { prop: "startDate" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.step2.startDate,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step2.startDate) = $event)),
                        placeholder: "Select a start date",
                        name: "startDate",
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateStartDate()))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Field, {
                    type: "hidden",
                    class: "form-control form-control-solid",
                    name: "startDate",
                    placeholder: "Select a start date",
                    value: "",
                    modelValue: _ctx.step2.startDate,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.step2.startDate) = $event)),
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.validateStartDate()))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "startDate",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createVNode(_component_el_form_item, { prop: "endDate" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.step2.endDate,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.step2.endDate) = $event)),
                        placeholder: "Select a end date",
                        name: "endDate",
                        onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.validateEndDate()))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Field, {
                    type: "hidden",
                    class: "form-control form-control-lg form-control-solid",
                    name: "endDate",
                    placeholder: "Select a end date",
                    value: "",
                    modelValue: _ctx.step2.endDate,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.step2.endDate) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "endDate",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ]))
}